module.exports = __webpack_public_path__ + "img/hot-close.865e2dd5.svg";